define('components/course/models/module',[
    'components/course/collections/sections',
    'components/course/models/base',
    'components/course/models/section',
    'components/course/models/theme-manager',
    'components/course/radio-channel'
], function (Sections, Base, Section, ThemeManager, channel) {
    "use strict";

    var ModuleEvent = channel.Event.Module,
        SaveStateEvent = ModuleEvent.State.Save,
        ThemeEvent = channel.Event.Theme;

    return Base.extend({
        "authoringJSONKey": function () {
            return _.extend(Base.prototype.authoringJSONKey.call(this), {
                "backgroundImage": null,
                "badgeImage": null,
                "description": null,
                "icon": null,
                "isUnlocked": null,
                "sections": null,
                "thumbnail": null
            });
        },

        "saveStateJSONKey": function () {
            return _.extend(Base.prototype.saveStateJSONKey.call(this), {
                "isBadgeEarned": null,
                "isComplete": null,
                "navDirection": null,
                "sections": null,
                "themeManager": null
            });
        },

        "childrenAttribute": "sections",

        "urls": {
            "editorial": "./module.cfc",
            "runtime": window.initData.appUrl + "/api:selfPacedCourse/module",
            "saveState": "/api/v1.0/learning_module/module"
        },

        "complexRelations": function () {
            var complexRelations = Base.prototype.complexRelations.call(this);

            complexRelations = _.union(complexRelations, [
                {
                    "attr": "sections",
                    "Class": Sections
                },
                {
                    "attr": "themeManager",
                    "Class": ThemeManager
                }
            ]);

            return complexRelations;
        },

        "defaults": function () {
            return _.extend(Base.prototype.defaults.call(this), {
                "backgroundImage": null,
                "badgeImage": null,
                "description": null,
                "icon": null,
                "isBadgeEarned": false,
                "isComplete": false,
                "isUnlocked": false,
                "navDirection": 1,
                "themeManager": new ThemeManager(),
                "thumbnail": null,
                "title": null,
                "sections": null,
                "levelNum": null,
                "moduleNum": null
            });
        },

        "initialize": function () {
            this.listenTo(this, 'change:sections', this.onSectionsChange)
                .listenTo(this, 'save-state:success', this.onSaveStateSuccess)
                .listenTo(this, 'save-state:error', this.onSaveStateError);

            this.onSectionsChange(this, this.get('sections'));

            this.initRadioComm();
        },

        "initRadioComm": function () {
            channel.comply(ModuleEvent.COMPLETE, this.setIsComplete, this)
                   .comply(ModuleEvent.NAV_DIRECTION, this.setNavigationDirection, this)
                   .comply(SaveStateEvent.INIT, this.onSaveStateCommand, this);

            channel.reply(ModuleEvent.GET, function () { return this; }, this)
                   .reply(ModuleEvent.NAV_DIRECTION, this.getNavigationDirection, this);
        },

        "fetch": function () {
            var requestOptions = this.getRequestOptions('fetch'),
                deferred = new $.Deferred();

            $.ajax(requestOptions).done(function (response) {
                var sectionsPendingSync = response.children && response.children.length || 0,
                    resolveDeferred;

                resolveDeferred = _.bind(function () {
                    deferred.resolve(response);
                    this.set(this.parse(response));
                    this.trigger('sync', this);
                }, this);

                if (!sectionsPendingSync) {
                    resolveDeferred();
                    return;
                }

                _.each(response.children, function (section) {
                    var sectionModel = new Section({
                        "_id": section._id
                    });

                    sectionModel.once('sync', _.bind(function () {
                        section.slides = sectionModel.get('slides').toAuthoringJSON();
                        sectionsPendingSync--;

                        if (sectionsPendingSync === 0) {
                            resolveDeferred();
                        }
                    }, this));

                    sectionModel.fetch();
                }, this);
            });

            this.trigger('fetch', this, deferred);

            return deferred;
        },

        "getActiveSection": function () {
            return this.get('sections').getActiveSection();
        },

        "getRadioChannel": function () {
            return channel;
        },

        "getNavigationDirection": function () {
            return this.get('navDirection');
        },

        "setNavigationDirection": function (navDirection) {
            return this.set('navDirection', navDirection);
        },

        "onSaveStateCommand": function () {
            this.saveState();
        },

        "onSectionsChange": function (module, sections) {
            var activeSection = this.getActiveSection();

            if (activeSection) {
                activeSection.set('isActive', false);
            }

            if (sections.length) {
                activeSection = sections.at(0);
                activeSection.set('isActive', true);
                activeSection.setActiveSlide(0);
            }
        },

        "setIsComplete": function (isComplete) {
            this.set('isComplete', isComplete);
        },

        "toJSON": function () {
            var jsonData = Base.prototype.toJSON.call(this),
                activeSection = this.getActiveSection();

            jsonData.activeSection = activeSection && activeSection.toJSON();

            return jsonData;
        },

        "onSaveStateSuccess": function () {
            // This is a trigger event, different from
            // the command event that actually saves the module.
            // This trigger is for every listener that wants
            // to know when the module did a save.
            channel.trigger(SaveStateEvent.SUCCESS, this);
            channel.trigger(SaveStateEvent.COMPLETE, this, 'success');
        },

        "onSaveStateError": function () {
            channel.trigger(SaveStateEvent.ERROR, this);
            channel.trigger(SaveStateEvent.COMPLETE, this, 'error');
        }
    });
});

